import React, { useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import '../Features.css';

const Transparency = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.getElementById('home').classList.add('featureContent');
    return () => {
      document.getElementById('home').classList.remove('featureContent');
    };
  });
  useEffect(() => {
    setTimeout(() => {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }, 100);
  }, []);
  return (
    <Container className="featurePages transparency">
      <div className="header">
        <div className="headerContent">
          <h2 className="title">{t('contents:transparencyTitle1')}</h2>
          <p className="text">{t('contents:transparencyParagraph1')}</p>
        </div>
        <img
          src={require('../../../assets/images/features/pages/transparency/transparency_01.png')}
        />
      </div>
      <div className="content">
        <div className="container">
          <div className="section section01">
            <div className="textBox">
              <p>
                {t('contents:transparencyParagraph2')}
                <br />
                {t('contents:transparencyParagraph3')}
                <br />
                <br />
              </p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/transparency/transparency.png')}
              />
            </div>
          </div>
          <div className="section section02">
            <div className="textBox">
              <h2 className="title">{t('contents:transparencyTitle2')}</h2>
              <p>{t('contents:transparencyParagraph4')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/transparency/vibino-feature-Transparent-pic2.jpg')}
              />
            </div>
          </div>
          <div className="section section03">
            <div className="textBox">
              <h2 className="title">{t('contents:transparencyTitle3')}</h2>
              <p>{t('contents:transparencyParagraph5')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/transparency/vibino-feature-Transparent-pic6.jpg')}
              />
            </div>
          </div>
          <div className="section section04">
            <div className="textBox">
              <h2 className="title">{t('contents:transparencyTitle5')}</h2>
              <p>{t('contents:transparencyParagraph7')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/transparency/transparency-image5.jpg')}
              />
            </div>
          </div>
          <div className="section section05">
            <div className="textBox">
              <h2 className="title">{t('contents:transparencyTitle4')}</h2>
              <p>{t('contents:transparencyParagraph6')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/transparency/transparency4.jpg')}
              />
            </div>
          </div>
          <div className="section section06">
            <div className="textBox">
              <h2 className="title">{t('contents:transparencyTitle6')}</h2>
              <p>{t('contents:transparencyParagraph8')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/transparency/vibino-feature-Transparent-pic3.jpg')}
              />
            </div>
          </div>
        </div>
        <div className="footer"></div>
      </div>
    </Container>
  );
};

export default Transparency;
